import { render, staticRenderFns } from "./fieldCustomCheckbox.vue?vue&type=template&id=28988a71"
import script from "./fieldCustomCheckbox.vue?vue&type=script&lang=js"
export * from "./fieldCustomCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports